export class BillingInfoError extends Error {
    constructor(message?: string) {
        super(message);
        this.name = "BillingInfoError";
    }
}
